import { render, staticRenderFns } from "./AiChatbotButton.vue?vue&type=template&id=498d77a2&scoped=true"
import script from "./AiChatbotButton.vue?vue&type=script&lang=ts"
export * from "./AiChatbotButton.vue?vue&type=script&lang=ts"
import style0 from "./AiChatbotButton.vue?vue&type=style&index=0&id=498d77a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498d77a2",
  null
  
)

export default component.exports